// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dpu-table-container {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: var(--background-color-4);
}
.dpu-table-container .no-data {
  width: 100%;
  height: 100%;
  color: var(--color-text-3);
  display: flex;
  align-items: center;
  justify-content: center;
}
.info-table {
  width: 100%;
  border-collapse: collapse; /* Xóa khoảng cách giữa các ô */
  border: 1px solid var(--border-color-1);
  border-width: 1px; /* Top = 0, Right = 1px, Bottom = 1px, Left = 1px */
}

.info-table th {
  background-color: var(--background-color-2);
  text-align: left;
  padding: 10px;
  border: 1px solid var(--border-color-1); /* Đường viền giữa các tiêu đề */
}

.info-table td {
  border: 1px solid var(--border-color-1); /* Đường viền giữa các ô */
  padding: 2px;
  vertical-align: top;
}

.info-table tr:nth-child(even) {
  background-color: var(--background-color-2);
}

.info-table tr:nth-child(1) td {
  border-top: none;
}
.dpu-container-master-row .key,
.dpu-container-master-row .value,
.dpu-container-master-row .unit {
  font-size: 12px;
  text-align: left; /* Căn trái cho cột Key */
  position: absolute;
  left: 3px;
  top: 3px;
  right: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* .value {
  min-width: 50px;

} */
.dpu-container-master-row .content-td {
  position: relative;
}
.dpu-container-master-row .content-td::before {
  content: "&nbsp;";
  visibility: hidden;
}
.dpu-container-master-row .content-td.content-td-key {
  width: 30%;
}
.dpu-container-master-row .content-td.content-td-value {
  width: 70%;
}
.dpu-container-master-row .unit {
  min-width: 35px;
}
.dpu-container-master-row {
  width: 100%;
}
.dpu-container-master-row.open .dpu-row-table .dpu-arrow {
  transform: rotate(0deg);
}
.dpu-container-master-row.open .container-table {
  padding: 2px;
}
.container-table {
  width: 100%;
  padding: 10px;
  overflow: hidden;
}
.dpu-row-table {
  position: sticky;
  z-index: 10;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  cursor: pointer;
  background-color: var(--dropdown-background-color-1);
  /* background-image: linear-gradient(
    var(--dropdown-background-color-1),
    var(--dropdown-background-color-2)
  ); */
  /* border: 1px solid var(--border-color-1); */
  /* box-shadow: rgba(0, 0, 0, 0.01) 0px 2px 1px, rgba(0, 0, 0, 0.01) 0px 4px 2px,
    rgba(0, 0, 0, 0.01) 0px 8px 4px, rgba(0, 0, 0, 0.03) 0px 16px 8px,
    rgba(0, 0, 0, 0.03) 0px 32px 16px; */
  /* box-shadow: 0px 3px 15px -10px #494949; */
}

.dpu-row-table .content-key {
  font-size: 12px;
  font-weight: bold;
  width: calc(100% - 20px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.dpu-row-table .dpu-arrow {
  width: 10px;
  height: 10px;
  line-height: 10px;
  fill: var(--color-text-1);
  transform: rotate(-90deg);
  transition: 0.1s;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-container img {
  animation: rotate 1s linear infinite;
}
`, "",{"version":3,"sources":["webpack://./src/styles/dataProperties.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;AAC7C;AACA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,yBAAyB,EAAE,+BAA+B;EAC1D,uCAAuC;EACvC,iBAAiB,EAAE,mDAAmD;AACxE;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,uCAAuC,EAAE,gCAAgC;AAC3E;;AAEA;EACE,uCAAuC,EAAE,0BAA0B;EACnE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;AAClB;AACA;;;EAGE,eAAe;EACf,gBAAgB,EAAE,yBAAyB;EAC3C,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;GAGG;AACH;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,oDAAoD;EACpD;;;MAGI;EACJ,6CAA6C;EAC7C;;wCAEsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".dpu-table-container {\r\n  height: 100%;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  background-color: var(--background-color-4);\r\n}\r\n.dpu-table-container .no-data {\r\n  width: 100%;\r\n  height: 100%;\r\n  color: var(--color-text-3);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.info-table {\r\n  width: 100%;\r\n  border-collapse: collapse; /* Xóa khoảng cách giữa các ô */\r\n  border: 1px solid var(--border-color-1);\r\n  border-width: 1px; /* Top = 0, Right = 1px, Bottom = 1px, Left = 1px */\r\n}\r\n\r\n.info-table th {\r\n  background-color: var(--background-color-2);\r\n  text-align: left;\r\n  padding: 10px;\r\n  border: 1px solid var(--border-color-1); /* Đường viền giữa các tiêu đề */\r\n}\r\n\r\n.info-table td {\r\n  border: 1px solid var(--border-color-1); /* Đường viền giữa các ô */\r\n  padding: 2px;\r\n  vertical-align: top;\r\n}\r\n\r\n.info-table tr:nth-child(even) {\r\n  background-color: var(--background-color-2);\r\n}\r\n\r\n.info-table tr:nth-child(1) td {\r\n  border-top: none;\r\n}\r\n.dpu-container-master-row .key,\r\n.dpu-container-master-row .value,\r\n.dpu-container-master-row .unit {\r\n  font-size: 12px;\r\n  text-align: left; /* Căn trái cho cột Key */\r\n  position: absolute;\r\n  left: 3px;\r\n  top: 3px;\r\n  right: 0;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n/* .value {\r\n  min-width: 50px;\r\n\r\n} */\r\n.dpu-container-master-row .content-td {\r\n  position: relative;\r\n}\r\n.dpu-container-master-row .content-td::before {\r\n  content: \"&nbsp;\";\r\n  visibility: hidden;\r\n}\r\n.dpu-container-master-row .content-td.content-td-key {\r\n  width: 30%;\r\n}\r\n.dpu-container-master-row .content-td.content-td-value {\r\n  width: 70%;\r\n}\r\n.dpu-container-master-row .unit {\r\n  min-width: 35px;\r\n}\r\n.dpu-container-master-row {\r\n  width: 100%;\r\n}\r\n.dpu-container-master-row.open .dpu-row-table .dpu-arrow {\r\n  transform: rotate(0deg);\r\n}\r\n.dpu-container-master-row.open .container-table {\r\n  padding: 2px;\r\n}\r\n.container-table {\r\n  width: 100%;\r\n  padding: 10px;\r\n  overflow: hidden;\r\n}\r\n.dpu-row-table {\r\n  position: sticky;\r\n  z-index: 10;\r\n  top: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 6px 8px;\r\n  cursor: pointer;\r\n  background-color: var(--dropdown-background-color-1);\r\n  /* background-image: linear-gradient(\r\n    var(--dropdown-background-color-1),\r\n    var(--dropdown-background-color-2)\r\n  ); */\r\n  /* border: 1px solid var(--border-color-1); */\r\n  /* box-shadow: rgba(0, 0, 0, 0.01) 0px 2px 1px, rgba(0, 0, 0, 0.01) 0px 4px 2px,\r\n    rgba(0, 0, 0, 0.01) 0px 8px 4px, rgba(0, 0, 0, 0.03) 0px 16px 8px,\r\n    rgba(0, 0, 0, 0.03) 0px 32px 16px; */\r\n  /* box-shadow: 0px 3px 15px -10px #494949; */\r\n}\r\n\r\n.dpu-row-table .content-key {\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  width: calc(100% - 20px);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n.dpu-row-table .dpu-arrow {\r\n  width: 10px;\r\n  height: 10px;\r\n  line-height: 10px;\r\n  fill: var(--color-text-1);\r\n  transform: rotate(-90deg);\r\n  transition: 0.1s;\r\n}\r\n\r\n@keyframes rotate {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.loading-container img {\r\n  animation: rotate 1s linear infinite;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
